import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle } from 'lucide-react';

const DeleteConfirmModal = ({ open, onClose, onConfirm, expenseDetails }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="delete-confirm-modal" className="bg-card border-border max-w-sm">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <AlertTriangle className="w-8 h-8 text-destructive" />
            <DialogTitle className="text-2xl font-heading">Delete Expense?</DialogTitle>
          </div>
        </DialogHeader>

        {expenseDetails && (
          <div className="space-y-4 py-4">
            <p className="text-muted-foreground">
              Are you sure you want to delete this expense?
            </p>
            
            <div className="bg-secondary/50 rounded-lg p-4 space-y-2">
              <div className="flex justify-between">
                <span className="text-sm text-muted-foreground">Category:</span>
                <span className="text-sm font-semibold">{expenseDetails.category}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-muted-foreground">Amount:</span>
                <span className="text-sm font-semibold">${expenseDetails.amount.toFixed(2)}</span>
              </div>
              {expenseDetails.note && (
                <div className="flex justify-between">
                  <span className="text-sm text-muted-foreground">Note:</span>
                  <span className="text-sm font-semibold">{expenseDetails.note.split('|')[0].trim()}</span>
                </div>
              )}
            </div>

            <p className="text-xs text-muted-foreground">
              This action cannot be undone.
            </p>
          </div>
        )}

        <div className="flex gap-3 pt-2">
          <Button
            data-testid="cancel-delete-button"
            onClick={onClose}
            variant="outline"
            className="flex-1 rounded-full border-border"
          >
            Cancel
          </Button>
          <Button
            data-testid="confirm-delete-button"
            onClick={onConfirm}
            variant="destructive"
            className="flex-1 rounded-full"
          >
            Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmModal;
